import { IStore } from "..";
import { TOutboundCampaignFilterRequest, TOutboundCampaignReducerState } from "../../app/types/outbound-campaign-manager-types";

export const getFilters = (state: IStore): Partial<TOutboundCampaignFilterRequest> => state.outboundCampaignManagerReducer.filters;
export const getState = (state:IStore): TOutboundCampaignReducerState => state.outboundCampaignManagerReducer;